"use client"

import { Zap } from 'lucide-react'

interface IconicIntegrationProps {
  variant?: 'light' | 'dark'
  className?: string
}

/**
 * Iconic Integration component with lightning bolt icon and stacked text
 * Features two variants optimized for different backgrounds
 */
export function IconicIntegration({ variant = 'light', className }: IconicIntegrationProps) {
  const baseClasses = "inline-flex items-center gap-2 px-4 py-2 rounded-lg transition-colors"
  
  if (variant === 'dark') {
    const darkClasses = "bg-white/10 backdrop-blur-sm hover:bg-white/20 border border-white/20"
    return (
      <div className={`${baseClasses} ${darkClasses} ${className || ''}`}>
        <Zap className="w-4 h-4 text-yellow-400" />
        <div className="flex flex-col">
          <span className="text-xs text-white/70 font-sans leading-none">Powered by</span>
          <span className="text-sm font-bold text-white font-serif tracking-wide leading-none">KREK</span>
        </div>
      </div>
    )
  }

  const lightClasses = "bg-muted hover:bg-card"
  return (
    <div className={`${baseClasses} ${lightClasses} ${className || ''}`}>
      <Zap className="w-4 h-4 text-accent" />
      <div className="flex flex-col">
        <span className="text-xs text-muted-foreground font-sans leading-none">Powered by</span>
        <span className="text-sm font-bold text-primary font-serif tracking-wide leading-none">KREK</span>
      </div>
    </div>
  )
}
